export enum ToastNotificationType {
	Error = 'An error has occurred!',
	Warning = 'Uh oh, something went wrong!',
	Info = 'Did you know?',
	// Success = 'Yay! Everything worked!' //Could be updated
	Success = 'Successful!'
}
